import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Modal } from 'react-bootstrap';
import { matchPath } from 'react-router';

import i18n from '../../../i18n';
import Utils from '../../../utils/utils';
import Api from '../../../api/Api';
import store from '../../../store';
import { notifyConversationUpdated } from '../../../utils/conversationSync';
import { MY_TRIP, HIS_TRIP } from '../../../constants/exchange';
import Screen from '../../../utils/Screen';
import Exchange from '../../../models/Exchange';
import Analytics from '../../../utils/analytics';
import InputRangeCalendar from '../../calendar/InputRangeCalendar';
import InputNumber from '../../form/InputNumber';
import Alert from '../../common/alert/Alert';
import ModificationSent from './ModificationSent';
import ConfirmModificationModal from './ConfirmModificationModal';
import { Icon } from '@homeexchange/design';
class MutualExchangePopup extends React.PureComponent {
    static propTypes = {
        interlocutorFirstName: PropTypes.string.isRequired,
        convExchanges: PropTypes.arrayOf(PropTypes.instanceOf(Exchange)).isRequired,
        convId: PropTypes.number.isRequired,
        updateLoadingState: PropTypes.func.isRequired,
        showMutualModificationFormModal: PropTypes.bool.isRequired,
        closeMutualModificationFormModal: PropTypes.func.isRequired,
        availabilities: PropTypes.array.isRequired,
        interlocutorAvailabilities: PropTypes.array.isRequired,
        isCollection: PropTypes.bool.isRequired,
        userTotalGp: PropTypes.number.isRequired,
        fetchConversation: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            myTripDateRange: {
                from: null,
                to: null
            },
            hisTripDateRange: {
                from: null,
                to: null
            },
            oldMyTripDateRange: {
                from: null,
                to: null
            },
            oldHisTripDateRange: {
                from: null,
                to: null
            },
            myTripNbGuests: 0,
            oldMyTripNbGuests: 0,
            myTripNbGuestPoints: 0,
            hisTripNbGuests: 0,
            oldHisTripNbGuests: 0,
            hisTripNbGuestPoints: 0,
            disabledModifyButton: false,
            myTripIsAllowedToModify: false,
            hisTripIsAllowedToModify: false,
            modificationRequestOnGoing: false,
            fieldsUpdated: [],
            gpAmount: null,
            showConfirmationModal: false,
            shouldSetSubAutoRenew: false,
            shouldBuyGp: false
        };

        this.handleGuestsNbChange = this.handleGuestsNbChange.bind(this);
        this.modifyCurrentExchange = this.modifyCurrentExchange.bind(this);
        this.setPeriod = this.setPeriod.bind(this);
        this.myTripSetPeriod = this.myTripSetPeriod.bind(this);
        this.hisTripSetPeriod = this.hisTripSetPeriod.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.requestExchangeModification = this.requestExchangeModification.bind(this);
        this.toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
    }

    componentDidMount() {
        const { convExchanges } = this.props;

        this.setState({
            myTripNbGuests: convExchanges[0]?.get('guest_nb'),
            oldMyTripNbGuests: convExchanges[0]?.get('guest_nb'),
            myTripNbGuestPoints: convExchanges[0]?.get('guestpoint_amount'),
            hisTripNbGuests: convExchanges[1]?.get('guest_nb'),
            oldHisTripNbGuests: convExchanges[1]?.get('guest_nb'),
            hisTripNbGuestPoints: convExchanges[1]?.get('guestpoint_amount'),
            myTripDateRange: {
                from: moment(convExchanges[0]?.get('start_on')),
                to: moment(convExchanges[0]?.get('end_on'))
            },
            hisTripDateRange: {
                from: moment(convExchanges[1]?.get('start_on')),
                to: moment(convExchanges[1]?.get('end_on'))
            },
            oldMyTripDateRange: {
                from: moment(convExchanges[0]?.get('start_on')),
                to: moment(convExchanges[0]?.get('end_on'))
            },
            oldHisTripDateRange: {
                from: moment(convExchanges[1]?.get('start_on')),
                to: moment(convExchanges[1]?.get('end_on'))
            },
            myTripIsAllowedToModify: moment(convExchanges[0]?.get('start_on')).isBefore(moment(), 'day'),
            hisTripIsAllowedToModify: moment(convExchanges[1]?.get('start_on')).isBefore(moment(), 'day')
        });
    }

    toggleConfirmationModal() {
        this.setState({
            showConfirmationModal: !this.state.showConfirmationModal
        });
    }

    handleGuestsNbChange(e, whoseTrip) {
        const value = parseInt(e.target.value, 10);
        const element = `nbGuest_${whoseTrip}`;

        if (whoseTrip === MY_TRIP) {
            this.setState({ myTripNbGuests: value });
        }

        if (whoseTrip === HIS_TRIP) {
            this.setState({ hisTripNbGuests: value });
        }

        this.addFieldUpdated(element);

        if (
            (whoseTrip === MY_TRIP && value === this.state.oldMyTripNbGuests) ||
            (whoseTrip === HIS_TRIP && value === this.state.oldHisTripNbGuests)
        ) {
            this.removeFieldUpdated(element);
        }
    }

    myTripSetPeriod(period) {
        this.setPeriod(period, MY_TRIP);
    }

    hisTripSetPeriod(period) {
        this.setPeriod(period, HIS_TRIP);
    }

    setPeriod(period, whoseTrip) {
        // In case of one date is not filled in
        if (period.length < 2) {
            this.setState({
                disabledModifyButton: true
            });

            return;
        }

        const element = `period_${whoseTrip}`;
        this.addFieldUpdated(element);

        const startOn = moment(period[0], 'YYYY-MM-DD');
        const endOn = moment(period[1], 'YYYY-MM-DD');
        const newDateRange = {
            from: moment.isMoment(period[0]) ? startOn : null,
            to: moment.isMoment(period[1]) ? endOn : null
        };
        const nights = endOn.diff(startOn, 'days', true);

        if (
            (whoseTrip === MY_TRIP &&
                startOn.format('YYYY-MM-DD') ===
                    moment(this.state.oldMyTripDateRange.from).format('YYYY-MM-DD') &&
                endOn.format('YYYY-MM-DD') ===
                    moment(this.state.oldMyTripDateRange.to).format('YYYY-MM-DD')) ||
            (whoseTrip === HIS_TRIP &&
                startOn.format('YYYY-MM-DD') ===
                    moment(this.state.oldHisTripDateRange.from).format('YYYY-MM-DD') &&
                endOn.format('YYYY-MM-DD') === moment(this.state.oldHisTripDateRange.to).format('YYYY-MM-DD'))
        ) {
            this.removeFieldUpdated(element);
        }

        if (whoseTrip === MY_TRIP) {
            this.setState({
                myTripDateRange: newDateRange,
                myTripNbGuestPoints: nights * this.props.convExchanges[0]?.get('guestpoint_amount')
            });
        }

        if (whoseTrip === HIS_TRIP) {
            this.setState({
                hisTripDateRange: newDateRange,
                hisTripNbGuestPoints: nights * this.props.convExchanges[1]?.get('guestpoint_amount')
            });
        }

        this.setState({ disabledModifyButton: false });
    }

    addFieldUpdated(element) {
        if (!this.state.fieldsUpdated.includes(element)) {
            this.setState((prevState) => ({
                fieldsUpdated: [...prevState.fieldsUpdated, element]
            }));
        }
    }

    removeFieldUpdated(element) {
        this.setState({
            fieldsUpdated: this.state.fieldsUpdated.filter(function (field) {
                return field !== element;
            })
        });
    }

    getModificationData() {
        const { myTripDateRange, hisTripDateRange, myTripNbGuests, hisTripNbGuests } = this.state;

        return [
            {
                start_on: myTripDateRange.from.format('YYYY-MM-DD'),
                end_on: myTripDateRange.to.format('YYYY-MM-DD'),
                guest_nb: myTripNbGuests,
                host_id: this.props.convExchanges[0]?.get('host').get('id')
            },
            {
                start_on: hisTripDateRange.from.format('YYYY-MM-DD'),
                end_on: hisTripDateRange.to.format('YYYY-MM-DD'),
                guest_nb: hisTripNbGuests,
                host_id: this.props.convExchanges[1]?.get('host').get('id')
            }
        ];
    }

    requestExchangeModification() {
        this.setState({ modificationRequestOnGoing: true });

        const data = this.getModificationData();

        Api.Exchange.requestExchangeModification(this.props.convId, data).then(
            (response) => {
                const {
                    should_buy_gp: shouldBuyGp,
                    should_set_sub_autorenew: shouldSetSubAutoRenew,
                    gp_amount: gpAmount
                } = response;

                this.setState({ shouldBuyGp, shouldSetSubAutoRenew, gpAmount });

                if (shouldBuyGp || shouldSetSubAutoRenew) {
                    this.closeModal();
                    this.toggleConfirmationModal();
                } else {
                    this.modifyCurrentExchange();
                }

                Analytics.trackGTM('exchange_status', {
                    event_data: {
                        exchange_status: 'finalized',
                        modification_status: 'pending',
                        exchange_type: 'reciprocal_exchange',
                        collection: this.props.isCollection
                    }
                });
            },
            () => {
                sweetAlert({
                    icon: 'error',
                    title: i18n.t('common:an_error_occured'),
                    text: i18n.t('common:an_error_occured')
                });
            }
        );
    }

    modifyCurrentExchange(callback = null) {
        const exchangeData = this.getModificationData();

        Api.Exchange.modifyExchange(this.props.convId, exchangeData).then(
            () => {
                notifyConversationUpdated(this.props.convId, store.getState().user?.id);

                if (callback) {
                    callback();
                } else {
                    this.props.updateLoadingState();
                    this.closeModal();
                }

                sweetAlert({
                    content: (
                        <ModificationSent
                            confirmCallback={() => {
                                sweetAlert.close();

                                this.props.fetchConversation(this.props.convId).then(() => {
                                    if (matchPath('/:locale?/conversations/:id/infos', location.pathname)) {
                                        document.dispatchEvent(
                                            new CustomEvent('request_card', {
                                                detail: {
                                                    view: 'conversation'
                                                }
                                            })
                                        );
                                    }
                                });
                            }}
                        />
                    ),
                    closeOnClickOutside: false,
                    button: false,
                    className: 'modify-exchange-modal'
                });
            },
            (errors) => {
                this.closeModal();
                this.setState({ modificationRequestOnGoing: false });

                console.error(`[RECIPROCAL EXCHANGE MODIFICATION]: ${errors}`);

                sweetAlert({
                    icon: 'error',
                    title: i18n.t('common:an_error_occured'),
                    text: i18n.t('common:an_error_occured')
                });
            }
        );
    }

    closeModal() {
        this.props.closeMutualModificationFormModal();
        this.setState({ modificationRequestOnGoing: false });
        this.props.updateLoadingState();
    }

    getGPBalance() {
        if (!this.state.gpAmount) {
            return null;
        }
        return this.state.gpAmount - this.props.userTotalGp;
    }

    render() {
        const { interlocutorFirstName, convExchanges } = this.props;
        const {
            myTripNbGuests,
            hisTripNbGuests,
            disabledModifyButton,
            myTripIsAllowedToModify,
            hisTripIsAllowedToModify,
            modificationRequestOnGoing
        } = this.state;
        const hasModification = this.state.fieldsUpdated.length === 0;

        return (
            <>
                <Modal
                    show={this.props.showMutualModificationFormModal}
                    dialogClassName="modify-exchange-modal"
                >
                    <div className="modify-exchange-modal-content">
                        <div className="modify-modal-header">
                            <Icon id="close-modal-gp-exchange" name="Cross" onClick={this.closeModal} />
                            <h3 className="edit-title">
                                {i18n.t('exchange:modify-exchange.edit.modal.title')}
                            </h3>
                            <Alert
                                content={i18n.t('exchange:modify-exchange.edit.modal.warning.text')}
                                color="warning"
                                icon={<Icon name="InfoCircleOutline" />}
                            />
                        </div>
                        <div className="modify-modal-body">
                            <div className="modify-modal-body-form">
                                <div
                                    className={`modify-exchange-left-part ${
                                        myTripIsAllowedToModify ? 'calendar-v2-disabled' : ''
                                    }`}
                                >
                                    <p className="receiver-name">{i18n.t('exchange:your_exchange')}</p>
                                    <label className="input-field-label">
                                        {i18n.t('exchange:modify-exchange.exchange-dates.label')}
                                    </label>
                                    <InputRangeCalendar
                                        mode="range"
                                        nbMonths={Screen.isMobile() ? 1 : 2}
                                        classname={['search-calendar', 'hends-calendar-gp-exchange']}
                                        classNames="hends-calendar"
                                        startOn={moment(convExchanges[0]?.get('start_on'), 'YYYY-MM-DD')}
                                        endOn={moment(convExchanges[0]?.get('end_on'), 'YYYY-MM-DD')}
                                        selectedHandler={this.myTripSetPeriod}
                                        availabilities={this.props.availabilities}
                                    />
                                    <div className="guests-nb-input form-group">
                                        <label
                                            className="input-field-label guests-nb-input-label"
                                            htmlFor="guests_nb"
                                        >
                                            <span>{Utils.ucfirst(i18n.t('exchange:guest_nb'))}</span>
                                        </label>
                                        <InputNumber
                                            id="guests_nb"
                                            name="detail.guests_nb"
                                            value={myTripNbGuests || convExchanges[0]?.get('guest_nb') || '0'}
                                            onChange={(e) => this.handleGuestsNbChange(e, MY_TRIP)}
                                            min={1}
                                            max={convExchanges[0]?.get('home_capacity') || '0'}
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`modify-exchange-right-part ${
                                        hisTripIsAllowedToModify ? 'calendar-v2-disabled' : ''
                                    }`}
                                >
                                    <p className="receiver-name">
                                        {i18n.t('exchange:user_exchange', {
                                            first_name: Utils.ucfirst(interlocutorFirstName)
                                        })}
                                    </p>
                                    <label className="input-field-label">
                                        {i18n.t('exchange:modify-exchange.exchange-dates.label')}
                                    </label>
                                    <InputRangeCalendar
                                        mode="range"
                                        classname={['search-calendar', 'hends-calendar-gp-exchange']}
                                        nbMonths={Screen.isMobile() ? 1 : 2}
                                        classNames="hends-calendar"
                                        startOn={moment(convExchanges[1]?.get('start_on'), 'YYYY-MM-DD')}
                                        endOn={moment(convExchanges[1]?.get('end_on'), 'YYYY-MM-DD')}
                                        selectedHandler={this.hisTripSetPeriod}
                                        availabilities={this.props.interlocutorAvailabilities}
                                    />
                                    <div className="guests-nb-input form-group">
                                        <label className="input-field-label" htmlFor="guests_nb">
                                            <span>{Utils.ucfirst(i18n.t('exchange:guest_nb'))}</span>
                                        </label>
                                        <InputNumber
                                            id="guests_nb"
                                            name="detail.guests_nb"
                                            value={
                                                hisTripNbGuests || convExchanges[1]?.get('guest_nb') || '0'
                                            }
                                            onChange={(e) => this.handleGuestsNbChange(e, HIS_TRIP)}
                                            min={1}
                                            max={convExchanges[1]?.get('home_capacity') || '0'}
                                        />
                                    </div>
                                </div>
                            </div>
                            <button
                                id="submit-modify-mutual-exchange"
                                className={classNames('btn btn-primary send-request-btn btn-ajax', {
                                    sending: modificationRequestOnGoing
                                })}
                                onClick={this.requestExchangeModification}
                                disabled={hasModification || disabledModifyButton}
                            >
                                {i18n.t('exchange:contact.send_request')}
                            </button>
                            <div className="modify-modal-footer">
                                <p
                                    className="modify-modal-footer-text"
                                    dangerouslySetInnerHTML={{
                                        __html: i18n.t('exchange:modify-exchange.edit.footer.link')
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal show={this.state.showConfirmationModal} dialogClassName="modify-exchange-modal">
                    <ConfirmModificationModal
                        displayAutoRenewActivation={this.state.shouldSetSubAutoRenew}
                        displayGpPurchase={this.state.shouldBuyGp}
                        modifyExchange={this.modifyCurrentExchange}
                        closeConfirmationModal={this.toggleConfirmationModal}
                        gpAmount={this.getGPBalance()}
                    />
                </Modal>
            </>
        );
    }
}

export default MutualExchangePopup;
